import { useState, useEffect } from 'react';
import UserListItem from './UserListItem';
import { getFollowers, getFollowing } from '../../services/userService';

const FollowListModal = ({ isOpen, onClose, userId, type }) => {
  const [userIds, setUserIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  useEffect(() => {
    if (isOpen && userId) {
      loadUsers();
    }
  }, [isOpen, userId, type]);
  
  const loadUsers = async () => {
    setLoading(true);
    setError('');
    
    try {
      let result;
      if (type === 'followers') {
        result = await getFollowers(userId);
      } else {
        result = await getFollowing(userId);
      }
      
      if (result.success) {
        setUserIds(type === 'followers' ? result.followers : result.following);
      } else {
        setError(result.error);
      }
    } catch (err) {
      console.error('Error al cargar usuarios:', err);
      setError('Error al cargar usuarios');
    } finally {
      setLoading(false);
    }
  };
  
  const handleFollowChange = () => {
    // Opcional: recargar lista si necesario
    // Por ahora no es necesario porque el estado se maneja localmente en cada UserListItem
  };
  
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  
  if (!isOpen) return null;
  
  return (
    <div 
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <div 
        className="bg-white dark:bg-slate-800 rounded-xl max-w-md w-full max-h-[600px] flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-slate-700">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            {type === 'followers' ? 'Seguidores' : 'Siguiendo'}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-full transition-colors"
            aria-label="Cerrar"
          >
            <svg 
              className="w-5 h-5 text-gray-500 dark:text-gray-400" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
        </div>
        
        {/* Lista de usuarios */}
        <div className="flex-1 overflow-y-auto">
          {loading ? (
            <div className="p-8 text-center">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600 mx-auto mb-3"></div>
              <p className="text-gray-600 dark:text-gray-400">Cargando...</p>
            </div>
          ) : error ? (
            <div className="p-8 text-center">
              <svg 
                className="w-12 h-12 text-red-500 mx-auto mb-3" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              <p className="text-red-500 dark:text-red-400">{error}</p>
            </div>
          ) : userIds.length === 0 ? (
            <div className="p-8 text-center">
              <svg 
                className="w-12 h-12 text-gray-400 mx-auto mb-3" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" 
                />
              </svg>
              <p className="text-gray-500 dark:text-gray-400">
                {type === 'followers' ? 'Sin seguidores aún' : 'No sigue a nadie aún'}
              </p>
            </div>
          ) : (
            <div>
              {userIds.map(uid => (
                <UserListItem 
                  key={uid} 
                  userId={uid}
                  onFollowChange={handleFollowChange}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowListModal;
